import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import ExpandMenu from '../../../../assets/data/expanded-menu.json'
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { cloneDeep } from 'lodash';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ButtonWithTextMenuComponent } from "../../../shared/components/button-with-text-menu/button-with-text-menu.component";
import { AutoFocusModule } from 'primeng/autofocus';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { CustomizeFieldsComponent } from "../customize-fields/customize-fields.component";
import { CustomizeFieldsFactory } from '@shared/factories/customize-fields/customize-fields.factory';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ButtonWithTextMenuArrowComponent } from "../../../shared/components/button-with-text-menu-arrow/button-with-text-menu-arrow.component";

@Component({
  selector: 'form-configuration-modal',
  templateUrl: './form-configuration-modal.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    ButtonWithTextMenuComponent,
    AutoFocusModule,
    FormsModule,
    NgClass,
    SpanTooltipComponent,
    CustomizeFieldsComponent,
    DragDropModule,
    ButtonWithTextMenuArrowComponent]
})
export class FormConfigurationModalComponent implements OnInit {
  constructor(
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private globalCfg: GlobalCfgFactory,
    private route: ActivatedRoute,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<FormConfigurationModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private customizeFieldsFactory: CustomizeFieldsFactory) {}
  @ViewChild(CustomizeFieldsComponent) customizeFields: CustomizeFieldsComponent;
  skin: string = this.globalCfg.skin;
  configuration:any = this.dialogConfig.data;
  formConfiguration: any = {
    faceview: 'group',
    evaluationId: this.route.snapshot.firstChild?.params['evaluationId'],
    fieldContainer: {},
    conceptInfo: {},
    disabledGroup: false,
    disabledReport: false,
    reportId: '',
    changesInConfiguration: false,
    fieldList: {expandedMenu: ExpandMenu['menuConfigurationFormChannelView'].menu},
    channelReportItem: {
      keyName: 'label',
      maxWidth: '200px',
      fixedWidth: true
    },
    channelReportList: [{
      label: this.translate.instant('common.none'),
      fieldId: null
    }]
  }

  ngOnInit(): void {
    this.formConfiguration.fieldContainer = this.configuration.fieldContainer;
    this.formConfiguration.fieldContainer.editableName = true;
    this.formConfiguration.conceptInfo = this.configuration.conceptInfo;
    this.formConfiguration.showMessage = this.configuration.conceptInfo.hasInstances;
    if(this.formConfiguration.fieldContainer.fields?.length){
      this.formConfiguration.channelReportList = this.formConfiguration.channelReportList.concat(this.formConfiguration.fieldContainer.fields);
      this.formConfiguration.selectedChannelReportField = this.formConfiguration.channelReportList[0];
    }
    this.closeFields();
    this.getContentType();
    this.getListValueColors();
    this.getReportId();
  }

  getContentType(){
    this.apiService.get('fields', 'contentTypes')
      .then((data:any)=>{
        let contentTypeList = this.commonUtilsService.editList(data, 'fieldContentTypeId', 'name');
        this.customizeFieldsFactory.setContentTypeList(contentTypeList);
      }, ()=>{})
  }

  getListValueColors() {
    this.apiService.get('listValues', 'colors')
      .then((data:any)=> {
          this.customizeFieldsFactory.setListValueColors(data);
      }, ()=>{});
  }

  getReportId(){
    this.apiService.get('reports/communicationchannel', this.formConfiguration.conceptInfo.productId)
      .then((data:any)=>{
        this.formConfiguration.reportId = data;
        if(this.formConfiguration.fieldContainer.fields?.length){
          this.getCustomField();
          this.getReportsCount();
        }
      }, ()=>{})
  }

  getCustomField(){
    this.apiService.get('denunc/dashboard/getcustomfield/'+this.formConfiguration.reportId, this.formConfiguration.evaluationId)
      .then((data:any)=>{
        if(data){
          for(let i = 0; i < this.formConfiguration.fieldContainer.fields.length; i++){
            if(this.formConfiguration.fieldContainer.fields[i].fieldId === data){
              this.formConfiguration.selectedChannelReportField = this.formConfiguration.fieldContainer.fields[i];
              this.formConfiguration.prechargedCustomField = data;
              break;
            }
          }
        }
      }, ()=>{})
  }

  getReportsCount(){
    this.apiService.get('reportobjects/objectscount/' + this.formConfiguration.evaluationId, this.formConfiguration.reportId)
      .then((data:any)=>{
        if(data){
          this.formConfiguration.disabledReport = true;
        }
      }, ()=>{})
  }

  reorderFields(event: any){
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    event.container.data.forEach((item: any, index: any) => {
      item.numOrder = index+1;
    });
    let fieldSelected = event.container.data[event.currentIndex];
    let numOrder: any = event.currentIndex < event.previousIndex?fieldSelected.numOrder-1:fieldSelected.numOrder;
    this.apiService.patch('fields/'+fieldSelected.fieldId, 'reorder/'+numOrder).then((data:any)=>{}, (errorData:any)=>{});
  }

  addNewField(field: any){
    let newField: any = {
      fieldTypeId: field.action,
      icon: field.icon,
      name: this.translate.instant(field.name),
      fieldId: this.commonUtilsService.createId(),
      new: true,
      label: this.translate.instant('customize-concept.new-field-name')
    }
    if(field.action === 'list'){
      newField.listValues = [];
    }
    this.formConfiguration.actionTypeField = 'create';
    this.selectEditField(newField);
  }

  selectEditField(configureField: any){
    configureField.open = true;
    this.formConfiguration.newField = configureField;
    let that: any = this;
    setTimeout(function(){
      let field: any = $('#customize-field-' + that.formConfiguration.newField.fieldId);
      field.focus().select();
    })
    this.formConfiguration.faceview = 'field';
  }

  fieldContainerNameChange(container:any){
    if(!container.name){
      let input: any = $('#group-form-configuration-' + container.fieldContainerId);
      input.focus().select();
      container.error = true;
    }else{
      if(container.name !== container.oldName){
        this.patchModifiedGroup(container);
      }
      container.editableName = false;
    }
  }

  patchModifiedGroup(fieldContainer:any){
    this.apiService.patch('fieldContainers', fieldContainer.fieldContainerId, fieldContainer)
      .then(()=>{
        fieldContainer.oldName = fieldContainer.name;
        this.formConfiguration.changesInConfiguration = true;
      }, ()=>{})
  }

  showField(e:any){
    if(e.action === 'edit'){
      this.selectEditField(cloneDeep(e.field));
    }else{
      this.configureOpenField(e.field);
    }
  }

  configureOpenField(field: any){
    if(!field.open){
      this.closeFields();
    }
    field.open = !field.open;
  }

  closeFields(){
    this.formConfiguration.fieldContainer.fields.forEach((fieldGroup:any) => {
      fieldGroup.open = false;
    })
  }

  saveField(){
    this.customizeFields.saveField();
  }

  closeField(){
    this.formConfiguration.faceview = 'group';
    delete this.formConfiguration.actionTypeField;
  }

  deleteField(){
    this.customizeFields.deleteField('modal');
  }

  launchAction(e:any){
    switch(e.action){
      case 'saved':
        e.field.open = false;
        this.configureOpenField(e.field);
        this.formConfiguration.fieldContainer.fields.push(e.field);
        this.formConfiguration.channelReportList.push(e.field);
        this.formConfiguration.faceview = 'group';
        this.formConfiguration.changesInConfiguration = true;
        delete this.formConfiguration.actionTypeField;
        break;
      case 'open':
        this.showField(e);
        break;
      case 'editField':
        this.formConfiguration.actionTypeField = 'edit';
        this.selectEditField(e.field);
        break;
      case 'deleted':
        this.formConfiguration.faceview = 'group';
        this.formConfiguration.changesInConfiguration = true;
        delete this.formConfiguration.actionTypeField;
        this.formConfiguration.channelReportList = this.commonUtilsService.deleteElement(e.field, this.formConfiguration.channelReportList, 'fieldId');
        if(this.formConfiguration.selectedChannelReportField?.fieldId === e.field.fieldId){
          this.formConfiguration.selectedChannelReportField = this.formConfiguration.channelReportList[0];
        }
        break;
    }
  }

  selectChannelReport(field: any){
    this.formConfiguration.selectedChannelReportField = field;
  }

  changeDropdown(openDropdown: any){
    this.formConfiguration[openDropdown] = !this.formConfiguration[openDropdown];
  }

  saveConfiguration(){
    if(this.formConfiguration.selectedChannelReportField?.fieldId && this.formConfiguration.prechargedCustomField !== this.formConfiguration.selectedChannelReportField?.fieldId){
      this.apiService.add('denunc/dashboard/setcustomfield/' + this.formConfiguration.reportId + '/'+this.formConfiguration.selectedChannelReportField.fieldId+'/'+this.formConfiguration.evaluationId)
        .then((data:any)=>{
          this.handleAccept();
        }, (errorData)=>{
          this.loader.closeError();
        });
    }else{
      this.handleAccept();
    }
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      fieldContainer: this.formConfiguration.fieldContainer,
      changesInConfiguration: this.formConfiguration.changesInConfiguration
    });
  }

  handleDismiss(){
    this.dialogRef.close({
      result: 'cancel',
      fieldContainer: this.formConfiguration.fieldContainer,
      changesInConfiguration: this.formConfiguration.changesInConfiguration
    });
  }
}
